import * as THREE from 'three';

class MakerlabEnvironmentBackground {

    constructor(el, fov = 70) {
        this.container = el;
        this.fov = fov;

        this.scene;
        this.camera;
        this.mesh = null;
        this.mouse = {x: 0, y: 0};
        this.cameraMoves = {x: 0, y: 0, z: -0.1, move: false, speed: 0.01};


        this.onMouseMove = this.handleMouseMove.bind(this);
        this.onResize = this.handleResize.bind(this);
    }

    init() {
        this.initScene();
        // this.base();
        this.environment();
        this.registerEvents();
        this.final();
    }

    registerEvents() {
        window.addEventListener('mousemove', this.onMouseMove);
        window.addEventListener('resize', this.onResize);

    }

    initScene() {
        this.camera = new THREE.PerspectiveCamera(this.fov, this.getFrameWidth() / this.getFrameHeight(), 0.01, 10000);
        this.camera.position.z = 2;

        this.scene = new THREE.Scene();
        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true
        });
        this.renderer.setPixelRatio(window.devicePixelRatio);

        this.renderer.setSize(this.getFrameWidth(), this.getFrameHeight());
        this.renderer.setClearColor(0xFFFFFFF, 1);
    }


    environment() {

        this.floor();
        this.hills();
    }

    hills() {
        const multiplier = 0.2;
        const texture = new THREE.TextureLoader().load('/images/awesome_hills.png');
        let g = new THREE.PlaneBufferGeometry((3686 * multiplier),(110 * multiplier), 50, 50);

        let mt = new THREE.MeshBasicMaterial({
            map: texture,
            transparent: true
        });
        let ms = new THREE.Mesh(g, mt);

        ms.position.set(0, 7, -200)
        ms.rotation.set(0, 0, 0);
        this.scene.add(ms);
    }

    floor() {
        const texture = new THREE.TextureLoader().load('/images/awesome_grid.jpg');
        let g = new THREE.PlaneBufferGeometry(1000, 1000, 50, 50);
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(200, 200);
        let mt = new THREE.MeshBasicMaterial({
            map: texture
        });
        let ms = new THREE.Mesh(g, mt);

        ms.position.set(0, -4, 300)
        ms.rotation.set(THREE.MathUtils.degToRad(-90), 0, 0);
        this.scene.add(ms);
    }

    getFrameHeight() {
        return this.container.offsetHeight;
    }

    getFrameWidth() {
        return this.container.offsetWidth;
    }


    handleMouseMove(e) {
        this.camera.position.x += Math.max(Math.min((e.clientX - this.mouse.x) * 0.01, this.cameraMoves.speed), -this.cameraMoves.speed);
        this.camera.position.y += Math.max(Math.min((this.mouse.y - e.clientY) * 0.01, this.cameraMoves.speed), -this.cameraMoves.speed);

        this.mouse.x = e.clientX;
        this.mouse.y = e.clientY;
    }

    handleResize() {
        this.camera.aspect = this.getFrameWidth() / this.getFrameHeight();
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.getFrameWidth(), this.getFrameHeight());
    }


    base() {
        const geometry = new THREE.BoxGeometry(0.2, 0.2, 0.2);
        const material = new THREE.MeshNormalMaterial();
        const axesHelper = new THREE.AxesHelper(5);
        this.scene.add(axesHelper);
        this.mesh = new THREE.Mesh(geometry, material);
        this.scene.add(this.mesh);
    }

    final() {

        this.renderer.setAnimationLoop(this.animation.bind(this));

        this.container.appendChild(this.renderer.domElement);



    }

    animation(time) {

        if (this.mesh) {
            this.mesh.rotation.x = time / 2000;
            this.mesh.rotation.y = time / 1000;

        }

        this.renderer.render(this.scene, this.camera);

    }

    static make(el) {
        const fov = el.getAttribute('data-fov') ? parseInt(el.getAttribute('data-fov')) : 70;

        return new MakerlabEnvironmentBackground(el, fov);
    }
}

export default MakerlabEnvironmentBackground;





document.addEventListener('readystatechange', () => {

    const el = document.getElementById('makerlab-env-bg');

    if (el) {
            MakerlabEnvironmentBackground.make(el).init();

    }


});

